(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-discovery-mosaic"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function slice(x){ return Array.prototype.slice.call(x); }
  function prefersReduced(){ return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function hashString(str){
    var h = 2166136261;
    for (var i = 0; i < str.length; i++){ h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function mulberry32(a){
    return function(){
      var t = a += 0x6D2B79F5;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function randomSeed(){ return (Math.floor(Math.random() * 4294967295)) >>> 0; }

  function getSeed(mode, sid, designMode){
    if (designMode) return 987654321;            // estable dentro del editor
    var now = new Date();
    if (mode === 'daily'){
      var k = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
      return hashString('bdm-daily-' + sid + '-' + k);
    }
    if (mode === 'session'){
      var key = 'bdm-seed-' + sid;
      try {
        var v = sessionStorage.getItem(key);
        if (!v){ v = String(randomSeed()); sessionStorage.setItem(key, v); }
        return parseInt(v, 10) >>> 0;
      } catch (e){ return randomSeed(); }
    }
    return randomSeed();                          // reload
  }

  var ROLE_ORDER = {
    1: ['protagonist'],
    2: ['protagonist', 'feature'],
    3: ['protagonist', 'feature', 'hero-b'],
    4: ['protagonist', 'feature', 'small-a', 'hero-b'],
    5: ['protagonist', 'feature', 'small-a', 'small-b', 'hero-b']
  };
  var TARGET = { 'protagonist': 4, 'feature': 3, 'hero-b': 3, 'small-a': 2, 'small-b': 2 };

  function shapeDesktop(role, n){
    if (n <= 1) return 'single';
    if (role === 'protagonist'){ if (n >= 4) return 'quad'; if (n === 3) return 'trio-mix'; return 'duo-h'; }
    if (role === 'feature'){ if (n >= 3) return 'trio-h'; return 'duo-h'; }
    if (role === 'hero-b'){ if (n >= 3) return 'trio-v'; return 'duo-v'; }
    return 'duo-v'; // small
  }
  function shapeMobile(n){
    if (n <= 1) return 'single';
    if (n === 2) return 'duo-h';
    if (n === 3) return 'trio-mix';
    return 'quad';
  }
  function weightOf(p){ return p === 'high' ? 5 : (p === 'low' ? 1 : 3); }

  var ARROW =
    '<span>Ver marca</span>' +
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"></path><path d="m13 6 6 6-6 6"></path></svg>';

  function initRoot(root){
    var grid = root.querySelector('[data-bdm-grid]');
    var templates = slice(root.querySelectorAll('template[data-bdm-source]'));
    if (!grid || !templates.length) return;

    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var sid = root.getAttribute('data-section-id') || 'bdm';
    var mode = root.getAttribute('data-rotation-mode') || 'session';
    var wantN = Math.max(1, parseInt(root.getAttribute('data-brands-to-show') || '5', 10));
    var variety = root.getAttribute('data-layout-variety') === 'true';
    var doReveal = root.getAttribute('data-reveal') !== 'false';

    var rand = mulberry32(getSeed(mode, sid, designMode));

    function shuffle(list){
      var a = list.slice();
      for (var i = a.length - 1; i > 0; i--){
        var j = Math.floor(rand() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }
    function weightedPick(items){
      if (!items.length) return null;
      var total = 0, i;
      for (i = 0; i < items.length; i++) total += items[i].weight;
      var pt = rand() * total;
      for (i = 0; i < items.length; i++){ pt -= items[i].weight; if (pt <= 0) return items[i]; }
      return items[items.length - 1];
    }
    function drop(list, x){ var i = list.indexOf(x); if (i >= 0) list.splice(i, 1); }

    function parse(t){
      return {
        title: t.getAttribute('data-title') || '',
        url: t.getAttribute('data-url') || '#',
        logo: t.getAttribute('data-logo') || '',
        weight: weightOf(t.getAttribute('data-priority')),
        canFeature: t.getAttribute('data-can-feature') !== 'false',
        products: slice(t.content.querySelectorAll('[data-bdm-product]'))
      };
    }

    var sources = templates.map(parse);
    var rich = sources.filter(function (s){ return s.products.length >= 2; });
    var pool = rich.length >= 2 ? rich : sources.filter(function (s){ return s.products.length >= 1; });
    if (!pool.length){ root.style.display = 'none'; return; }

    var count = Math.min(wantN, pool.length, 5);
    var selected = [];

    if (designMode){
      // En el editor mostramos las primeras marcas en orden: predecible al configurar.
      selected = pool.slice(0, count);
    } else {
      var remaining = pool.slice();
      var feats = remaining.filter(function (s){ return s.canFeature; });
      var h1 = weightedPick(feats.length ? feats : remaining);
      if (h1){ selected.push(h1); drop(remaining, h1); }

      if (selected.length < count && remaining.length){
        var feats2 = remaining.filter(function (s){ return s.canFeature; });
        var h2 = weightedPick(feats2.length ? feats2 : remaining);
        if (h2){ selected.push(h2); drop(remaining, h2); }
      }
      while (selected.length < count && remaining.length){
        var nx = weightedPick(remaining);
        if (!nx) break;
        selected.push(nx); drop(remaining, nx);
      }
    }

    // La 2ª marca elegida (segunda protagonista) se envía al final -> posición "alta" derecha.
    var ordered = selected.slice();
    if (ordered.length >= 2){ var second = ordered.splice(1, 1)[0]; ordered.push(second); }

    var roles = ROLE_ORDER[ordered.length] || ROLE_ORDER[5];

    var layout = 'a';
    if (variety && !designMode && ordered.length >= 4){ layout = rand() < 0.5 ? 'a' : 'b'; }

    function buildCard(src, role){
      var article = document.createElement('article');
      article.className = 'bdm-brand bdm-slot--' + role;

      // Fondo: reutiliza el MISMO archivo del logo (0 descargas extra, la copia se cachea).
      var bg = document.createElement('div');
      bg.className = 'bdm-brand__bg';
      if (src.logo){
        var bi = document.createElement('img');
        bi.src = src.logo; bi.alt = ''; bi.setAttribute('aria-hidden', 'true');
        bi.loading = 'lazy'; bi.decoding = 'async';
        bg.appendChild(bi);
      }

      var inner = document.createElement('div');
      inner.className = 'bdm-brand__inner';

      var top = document.createElement('div');
      top.className = 'bdm-brand__top';

      var head = document.createElement('a');
      head.className = 'bdm-brand__head';
      head.href = src.url;
      if (src.logo){
        var lg = document.createElement('img');
        lg.className = 'bdm-brand__logo';
        lg.src = src.logo; lg.alt = src.title;
        lg.loading = 'lazy'; lg.decoding = 'async';
        head.appendChild(lg);
      } else {
        var nm = document.createElement('span');
        nm.className = 'bdm-brand__name';
        nm.textContent = src.title;
        head.appendChild(nm);
      }

      var link = document.createElement('a');
      link.className = 'bdm-brand__link';
      link.href = src.url;
      link.setAttribute('aria-label', 'Ver todos los productos de ' + src.title);
      link.innerHTML = ARROW;

      top.appendChild(head);
      top.appendChild(link);

      // Cantidades: desktop según slot, mobile hasta 4. Nunca dejamos celdas vacías.
      var availN = src.products.length;
      var target = TARGET[role] || 2;
      var dN = Math.min(target, availN);        // visibles en desktop
      var mN = Math.min(4, availN);             // visibles en mobile
      var renderN = Math.max(dN, mN);
      var useSmall = (role === 'small-a' || role === 'small-b');

      var chosen = shuffle(src.products).slice(0, renderN);

      var products = document.createElement('div');
      products.className = 'bdm-products';
      products.setAttribute('data-shape-d', shapeDesktop(role, dN));
      products.setAttribute('data-shape-m', shapeMobile(mN));

      chosen.forEach(function (node, i){
        var card = node.cloneNode(true);
        var img = card.querySelector('[data-bdm-product-image]');
        if (img){
          var big = card.getAttribute('data-image') || '';
          var sm = card.getAttribute('data-image-sm') || big;
          if (big || sm) img.src = useSmall ? sm : big;
        }
        if (i >= dN) card.className += ' is-extra'; // oculto en desktop, visible en mobile
        products.appendChild(card);
      });

      inner.appendChild(top);
      inner.appendChild(products);
      article.appendChild(bg);
      article.appendChild(inner);
      return article;
    }

    var frag = document.createDocumentFragment();
    ordered.forEach(function (src, idx){
      frag.appendChild(buildCard(src, roles[idx] || 'feature'));
    });

    var animate = doReveal && !designMode && !prefersReduced();

    grid.setAttribute('data-count', String(ordered.length));
    grid.setAttribute('data-layout', layout);
    grid.classList.toggle('is-animating', animate);
    grid.textContent = '';                 // idempotente: soporta reejecución (Theme Editor)
    grid.appendChild(frag);

    if (animate) reveal(grid);
  }

  function reveal(grid){
    var cards = slice(grid.querySelectorAll('.bdm-brand'));
    if (!cards.length) return;
    function show(){
      cards.forEach(function (c, i){ setTimeout(function (){ c.classList.add('is-visible'); }, i * 70); });
    }
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function (entries){
        for (var i = 0; i < entries.length; i++){
          if (entries[i].isIntersecting){ show(); io.disconnect(); return; }
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      io.observe(grid);
      // Seguridad: si por algún motivo no dispara, revelamos igual.
      setTimeout(function (){
        if (!grid.querySelector('.bdm-brand.is-visible')){ io.disconnect(); show(); }
      }, 1500);
    } else {
      show();
    }
  }

  function initAll(ctx){
    slice((ctx || document).querySelectorAll('.bdm-section[data-bdm-section]')).forEach(initRoot);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function (){ initAll(document); });
  } else {
    initAll(document);
  }

  // Theme Editor: reconstruir la sección al recargarla/editarla.
  document.addEventListener('shopify:section:load', function (e){
    var el = e.target && e.target.querySelector ? e.target.querySelector('.bdm-section[data-bdm-section]') : null;
    if (el) initRoot(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
